'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const utils_debounce = require('../../../utils/debounce.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
const components_display_Table_Vars = require('./Vars.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("Table", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: block;
    width: 100%;
    position: relative;

    &[data-scrollable] {
      overflow: auto;

      &[data-scrolled-horz] {
        ${components_display_Table_Vars.Vars.frozenCellHorzShadowOpacity}: 1;
      }

      &[data-scrolled-vert] {
        ${components_display_Table_Vars.Vars.frozenCellVertShadowOpacity}: 1;
      }
    }
  `,
  table: react.css`
    ${styleMixins_reset.boxSizing};
    display: table;
    border-spacing: 0;
    &[data-collapse] {
      border-collapse: collapse;
    }

    &[data-kind='standard'] {
      width: 100%;
      ${theme_Typography.Typography.Body1Multiline};
      color: ${theme_Colors.Colors.TextDefault};

      th,
      td {
        border-bottom: 1px solid ${theme_Colors.Colors.StrokeWeaker};
        background-color: ${theme_Colors.Colors.BackgroundWeaker};
        padding: var(--zds-space-12);
      }

      th {
        font-weight: unset;
      }

      tbody tr:hover {
        th,
        td {
          background-color: ${theme_Colors.Colors.UiPrimaryWeakest};
        }
      }
    }
  `
});
const Table = ({ scrollable, children, collapse = false, kind = "standard" }) => {
  const [isScrolledHorz, setIsScrolledHorz] = React.useState(false);
  const [isScrolledVert, setIsScrolledVert] = React.useState(false);
  const setScroll = utils_debounce.debounce((target) => {
    const { scrollLeft, scrollTop } = target;
    setIsScrolledHorz(scrollLeft > 0);
    setIsScrolledVert(scrollTop > 0);
  }, 20);
  const onScroll = (e) => {
    setScroll(e.target);
  };
  return react.jsx(
    "div",
    { css: Styles.root, "data-scrollable": scrollable ? "" : void 0, "data-scrolled-horz": isScrolledHorz ? "" : void 0, "data-scrolled-vert": isScrolledVert ? "" : void 0, "data-zds": true, onScroll },
    react.jsx("table", { css: Styles.table, "data-collapse": collapse ? "" : void 0, "data-kind": kind, "data-zds": true, role: "table" }, children)
  );
};

exports.Table = Table;
//# sourceMappingURL=Table.cjs.js.map
